import httpFactory, { HttpType } from "@/api/httpFactory";
export default {
    async getAll() {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get("acquisition-channels");
        return response.data;
    },
    async get(id) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get(`acquisition-channels/${id}`);
        return response.data;
    },
    async create(acquisitionChannelRequest) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.post("acquisition-channels/create", acquisitionChannelRequest);
        return response.data;
    },
    async edit(id, acquisitionChannelRequest) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.post(`acquisition-channels/${id}/edit`, acquisitionChannelRequest);
        return response.data;
    }
};
